<template>
  <div>
    <div class="page-wrapper">
      <div class="page-content-wrapper">
        <div class="shadow-btm">
          <div class="row">
            <div class="col-lg-12 col-sm-12 my-auto d-flex align-items-center mb-4">
              <a class="pr-2 text-dark cursor-pointer" v-on:click="$router.push('/company')">
                <span class="font-24 mr-2"><img src="/images/back-arrow.svg" width="18" /></span>
              </a>
              <h4 class="mb-0 lg-bld">{{ id ? "Edit" : "Add" }} Company</h4>
            </div>
          </div>
        </div>
        <div class="page-content">
          <div class="card-body py-0 px-0">
            <div class="row">
              <div class="col-lg-12 col-sm-10 float-none">
                <div class="card border mb-0 radius-15">
                  <div class="card-body">
                    <Form itemref="adminForm" @submit="save()">
                      <div class="col-12 row">
                        <div class="col-6">
                          <div class="col-12 form-group mb-5">
                            <label>Company Name</label>
                            <span class="text-danger">*</span>

                            <Field
                              type="text"
                              name="company_name"
                              class="form-control"
                              placeholder="Comapny Name"
                              v-model="detail.company_name"
                              rules="required:company name"
                              :validateOnInput="true"
                              v-slot="{ field }">
                              <Multiselect
                                mode="single"
                                trackBy="company_name"
                                label="company_name"
                                valueProp="company_name"
                                placeholder="Select"
                                v-model="detail.company_name"
                                :options="companyOptions"
                                :create-option="true"
                                :searchable="true"
                                v-bind="field"
                                @search-change="searchCompanyName($event)">
                                <template v-slot:option="{ option }">
                                  <img
                                    class="option-icon"
                                    :src="option.company_logo ? option.company_logo : '/img/user-pic.png'" />
                                  {{ option.company_name }}
                                </template>
                              </Multiselect>
                            </Field>
                            <ErrorMessage name="company_name" class="text-danger" />
                          </div>
                          <!-- 🔹 INDUSTRY SUGGESTION -->
                          <div
                            v-if="detail?.industry_suggestion_message"
                            class="alert alert-warning py-2 mb-2"
                          >
                            <strong>Possible industry matches:</strong>
                            <span class="ml-1">
                              {{ detail.industry_suggestion_message }}
                            </span>
                          </div>                          
                          <div class="col-12 form-group">
                            <label>Company Website</label>
                            <Field
                              type="text"
                              name="company_website"
                              class="form-control"
                              placeholder="Company Website"
                              v-model="detail.company_website"
                              rules="required:company website|website"
                              :validateOnInput="true" />
                              <ErrorMessage name="company_website" class="text-danger" />                              
                              <div v-if="!id" class="d-flex justify-content-end mt-2">
                                <button
                                  type="button"
                                  class="biography-buttn px-3 d-flex align-items-center"
                                  :disabled="companyAiLoader"
                                  @click="getCompanyDetailsAi"
                                >
                                  <!-- 🔥 LOADER -->
                                  <span
                                    v-if="companyAiLoader"
                                    class="spinner-border spinner-border-sm mr-2"
                                    role="status"
                                    aria-hidden="true"
                                  ></span>

                                  {{ companyAiLoader ? 'Fetching…' : 'Fetch Company (AI)' }}
                                </button>
                                <!-- 🔥 I BUTTON (JUST NEXT TO FETCH) v-if="singleCompanyShowOnUi" -->
                                <div
                                  v-if="singleCompanyShowOnUi"
                                  class="ai-info-wrapper ml-2"
                                  @click.stop
                                >
                                  <span class="ai-info-btn" @click="showSingleCompanyInfo = !showSingleCompanyInfo">ℹ️</span>
                                  <div v-if="showSingleCompanyInfo" class="ai-info-popup">
                                    <div class="ai-popup-header">
                                      <img
                                        :src="singleCompanyShowOnUi.CompanyImageUrl || '/img/user-pic.png'"
                                        class="ai-popup-avatar"
                                      />
                                    </div>

                                    <div
                                      v-for="(value, key) in singleCompanyShowOnUi"
                                      :key="key"
                                      class="ai-info-row"
                                    >
                                      <strong>{{ key }}</strong> {{ value }}
                                    </div>
                                  </div>
                                </div>

                              </div>
                          </div>
                        </div>

                        <div class="col-6">
                          <div class="col-6">
                            <label>Company Logo</label>
                            <ImagePicker
                              :src="detail.company_logo"
                              :modelValue="detail.company_logo"
                              ref="ImagePicker" />
                          </div>
                        </div>
                      </div>
                      <!-- ROW 1 : Non-editable Skills (TOP) -->
                      <div class="form-group" style="padding-left: 30px;">
                        <div class="row">
                          <div class="col-6 skill-multiselect-tag">
                            <label>Tags</label>
                            <Multiselect
                              mode="tags"
                              track-by="id"
                              label="name"
                              valueProp="id"
                              placeholder="Select"
                              v-model="detail.save_skill_ids"
                              :options="save_skill_list"
                              :disabled="true"
                              :showOptions="false" />
                          </div>
                        </div>

                        <!-- ROW 2 : Description (LEFT) + Editable Skills (RIGHT) -->
                        <div class="row mt-3">
                          <!-- LEFT : Description -->
                          <div class="col-md-6">
                            <div class="form-group">
                              <label>Description</label>

                              <div
                                v-if="!isEditingCompanyDesc"
                                class="form-control"
                                style="height: 125px; overflow-y: auto; background: #f9f9f9"
                                v-html="highlightedCompanyDesc"></div>

                              <textarea
                                v-else
                                class="form-control"
                                style="height: 125px"
                                v-model="detail.company_desc"></textarea>

                              <div class="mt-2 d-flex justify-content-end gap-2" style="gap: 5px;">
                                <button
                                  type="button"
                                  class="biography-buttn px-3"
                                  @click="onToggleHighlightCompanyDesc()">
                                  {{ isEditingCompanyDesc ? "Show Highlight" : "Highlight Entitity" }}
                                </button>

                                <button type="button" class="biography-buttn px-3" @click="prefillDropdown()">
                                  Prefill Dropdown
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- RIGHT : Editable Skills + Apply -->
                          <div class="col-md-6">
                            <div class="form-group skill-multiselect-tag">
                              <label>Tags</label>
                              <Multiselect
                                mode="tags"
                                track-by="id"
                                label="name"
                                valueProp="id"
                                placeholder="Select"
                                v-model="detail.skill_ids"
                                :options="skill_list"
                                @search-change="searchSkillName($event)"
                                :showOptions="false" />
                            </div>

                            <div class="d-flex justify-content-end mt-2">
                              <button type="button" class="biography-buttn px-3" @click="applyDropdowns(true)">
                                Apply
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 row" style="padding: 26px">
                        <div class="col-6 form-group">
                          <label>Team Page Website</label>
                          <Field
                            type="text"
                            name="Team_Page_Website"
                            class="form-control"
                            placeholder="Team Page Website"
                            v-model="detail.team_page_url"
                            rules="website"
                            :validateOnInput="true" />
                            <div v-if="id" class="d-flex justify-content-end mt-2">
                              <button
                                type="button"
                                class="biography-buttn px-3 d-flex align-items-center"
                                @click="openExecutiveModal"
                                :disabled="fetchTeamExecutivesLoading"
                              >
                                <!-- Loader -->
                                <span
                                  v-if="fetchTeamExecutivesLoading"
                                  class="spinner-border spinner-border-sm mr-2"
                                  role="status"
                                  aria-hidden="true"
                                ></span>

                                {{ fetchTeamExecutivesLoading ? 'Fetching…' : 'Fetch Team Members (AI)' }}
                              </button>
                            </div>
                          <ErrorMessage name="Team_Page_Website" class="text-danger" />
                        </div>

                        <div class="col-3 form-group">
                          <label for="inputRole">Industry Type</label>
                          <span class="text-danger">*</span>
                          <Field
                            as="select"
                            class="form-control"
                            id="inputRole"
                            name="industry"
                            rules="required:industry"
                            :validateOnInput="true"
                            :searchable="true"
                            v-model="detail.industry_id"
                            v-on:change="handleIndustryChange">
                            <option value="">Select Industry</option>
                            <option v-for="(data, index) in industryList" :key="index" :value="data.id">
                              {{ data.industry_name }}
                            </option>
                          </Field>
                          <ErrorMessage name="industry" class="text-danger" />
                        </div>
                        <div class="col-3 form-group" v-if="showTechType">
                          <label for="inputTechFocus">Tech Focus</label>
                          <!-- <span class="text-danger">*</span> -->
                          <Field
                            as="select"
                            class="form-control"
                            id="inputTechFocus"
                            name="tech_focus"
                            :validateOnInput="true"
                            v-model="detail.subsector_id">
                            <option value="">Select Tech Focus</option>
                            <option v-for="(data, index) in subsectorsList" :key="index" :value="data.id">
                              {{ data.industry_name }}
                            </option>
                          </Field>
                          <ErrorMessage name="tech_type" class="text-danger" />
                        </div>
                        <div class="col-3">
                          <label>Company Size</label>
                          <Field as="select" class="form-control" name="company_size" v-model="detail.company_size">
                            <option value="">Select Company Size</option>
                            <option value="1-10">1-10</option>
                            <option value="11-50">11-50</option>
                            <option value="51-200">51-200</option>
                            <option value="201-500">201-500</option>
                            <option value="501-1000">501-1000</option>
                            <option value="1001-5000">1001-5000</option>
                            <option value="5001-10000">5001-10000</option>
                            <option value="10000+">10000+</option>
                          </Field>
                        </div>

                        <div class="col-3 form-group">
                          <label for="inputRole">Revenue Range</label>
                          <!-- <span class="text-danger">*</span> -->
                          <Field
                            as="select"
                            class="form-control"
                            id="inputRole"
                            name="revenue"
                            v-model="detail.revenue_id">
                            <option value="">Select Revenue</option>
                            <option v-for="(data, index) in revenueList" :key="index" :value="data.id">
                              {{ data.range }}
                            </option>
                          </Field>
                        </div>
                        <div class="col-3">
                          <label>Currency</label>
                          <Field as="select" class="form-control" name="currency" v-model="detail.currency_id">
                            <option value="">Select Currency</option>
                            <option v-for="(data, index) in currencyList" :key="index" :value="data.id">
                              {{ data.currency_name }} ( {{ data.currency_code }} -{{ data.currency_symbol }})
                            </option>
                          </Field>
                        </div>

                        <div class="col-6 form-group">
                          <label>Company Type</label>
                          <span class="text-danger">*</span>
                          <Field
                            as="select"
                            class="form-control"
                            name="company_type"
                            v-model="detail.company_type"
                            rules="required:company type"
                            :validateOnInput="true">
                            <option value="">Select Company Type</option>
                            <option value="public">Public</option>
                            <option value="private">Private</option>
                            <option value="education">Education</option>
                            <option value="government">Government</option>
                            <option value="not-for-profit">Not for Profit</option>
                            <option value="venture funded">Venture Funded</option>
                            <option value="pe backed">PE Backed</option>
                          </Field>
                          <ErrorMessage name="company_type" class="text-danger" />
                        </div>
                        <div v-if="detail.company_type == 'public'" class="col-6 form-group">
                          <label>Ticker</label>
                          <span class="text-danger">*</span>
                          <Field
                            type="text"
                            name="ticker"
                            class="form-control"
                            placeholder="Ticker"
                            v-model="detail.ticker"
                            rules="required:ticker"
                            :validateOnInput="true" />
                          <ErrorMessage name="ticker" class="text-danger" />
                        </div>
                        <div class="col-3 form-group">
                          <label for="inputRole">Deal Stage</label>
                          <!-- <span class="text-danger">*</span> -->
                          <Field
                            as="select"
                            class="form-control"
                            id="inputRole"
                            name="deal_stage"
                            v-model="detail.deal_stage_id">
                            <option value="">Select Deal Stage</option>
                            <option v-for="(data, index) in deaStageList" :key="index" :value="data.id">
                              {{ data.name }}
                            </option>
                          </Field>
                        </div>
                        <div class="col-6 form-group"></div>
                        <hr />
                        <h3 class="col-10 sub-heading mt-4">Headquarters :-</h3>
                        <div class="col-6 form-group"></div>
                        <div class="col-8 form-group">
                          <label>Country</label>
                          <span class="text-danger">*</span>
                          <Field
                            type="text"
                            name="country_name"
                            placeholder="Select country"
                            rules="required: country"
                            :validateOnInput="true"
                            v-model="detail.country_id"
                            v-on:change="CityList(detail.country_id)"
                            v-slot="{ field }">
                            <Multiselect
                              mode="single"
                              trackBy="country_name"
                              label="country_name"
                              valueProp="id"
                              placeholder="Select Country"
                              v-model="detail.country_id"
                              :options="countryList"
                              :searchable="true"
                              v-bind="field" />
                          </Field>
                          <ErrorMessage name="country_name" class="text-danger" />
                        </div>

                        <div class="col-4 form-group">
                          <label>City</label>
                          <span class="text-danger">*</span>
                          <Field
                            type="text"
                            name="city_id"
                            placeholder="Select city"
                            v-model="detail.city_id"
                            rules="required:city"
                            :validateOnInput="true"
                            v-slot="{ field }">
                            <Multiselect
                              mode="single"
                              trackBy="city_name"
                              label="city_name"
                              valueProp="id"
                              v-model="detail.city_id"
                              :options="cityList"
                              :searchable="true"
                              placeholder="Select City"
                              @search-change="searchCityName($event)"
                              v-bind="field" />
                          </Field>
                          <ErrorMessage name="city_id" class="text-danger" />
                        </div>
                        <div class="col-4 form-group">
                          <label>Current Region</label>
                          <span class="text-danger">*</span>
                          <Field
                            type="text"
                            placeholder="Select"
                            name="NEW_REGION"
                            v-model="detail.region_id"
                            rules="required:  region"
                            :validateOnInput="true"
                            v-slot="{ field }">
                            <Multiselect
                              mode="single"
                              trackBy="region_name"
                              label="region_name"
                              valueProp="id"
                              placeholder="Select"
                              v-model="detail.region_id"
                              :options="regionList"
                              :searchable="true"
                              v-bind="field" />
                          </Field>
                          <ErrorMessage name="NEW_REGION" class="text-danger" />
                        </div>
                        <div class="col-4 form-group">
                          <label>Company Contact Number</label>
                          <!-- rules="required:contact number|phone" -->
                          <Field
                            type="text"
                            name="phone"
                            placeholder="Company Mobile"
                            v-model="detail.company_mobile"
                            v-slot="{ field }">
                            <PhoneCode
                              id="mobile"
                              placeholder="Company Mobile"
                              v-model:countryCode="detail.country_code"
                              v-model="detail.company_mobile"
                              v-model:dialCode="detail.dial_code"
                              v-bind="field" />
                          </Field>
                          <!-- <ErrorMessage name="phone" class="text-danger" /> -->
                        </div>
                        <div class="col-8 form-group"></div>
                      <!-- Segments -->
                      <div class="col-8 form-group skill-multiselect-tag">
                        <span>Segments</span>
                        <Field name="segment_ids" v-slot="{ field }">
                          <Multiselect
                            mode="tags"
                            track-by="id"
                            label="name"
                            valueProp="id"
                            placeholder="Select"
                            v-model="detail.segment_ids"
                            :options="segment_list"
                            :searchable="true"
                            v-bind="field"
                          >
                            <!-- 🔥 Add Segment option at bottom -->
                            <template #afterlist>
                              <div
                                class="multiselect-add-option"
                                @click.stop="openAddSegmentPopup"
                              >
                                + Add new segment
                              </div>
                            </template>
                          </Multiselect>
                        </Field>
                      </div>
                        <hr />
                        <h3 class="col-8 sub-heading mt-4">Social Media :-</h3>
                        <div v-for="(data, index) in detail.social_media" :key="index" class="col-12 row">
                          <div class="form-group col-3">
                            <Field
                              as="select"
                              class="form-control"
                              placeholder="Platform"
                              :name="'Platform_' + index"
                              v-model="data.platform_type">
                              <option value="">Select Platform</option>
                              <option value="LinkedIn">LinkedIn</option>
                              <option value="Facebook">Facebook</option>
                              <option value="Twitter">Twitter</option>
                            </Field>
                          </div>
                          <div class="form-group col-3">
                            <Field
                              type="text"
                              class="form-control"
                              :name="'URL_' + index"
                              placeholder="URL"
                              v-model="data.url"
                              rules="website"
                              :validateOnInput="true" />
                            <ErrorMessage :name="'URL_' + index" class="text-danger" />
                          </div>
                          <img
                            v-show="index == detail.social_media.length - 1 && detail.social_media.length <= 2"
                            v-on:click="addPlatform()"
                            src="/img/plus.png"
                            width="30"
                            height="30" />
                          <img
                            v-show="index != detail.social_media.length - 1 || index == 2"
                            v-on:click="removePlatform(index)"
                            src="/img/cross.png"
                            width="30"
                            height="30" />
                        </div>
                        <div class="col-6"></div>

                        <hr />
                        <div class="col-12 row">
                          <div class="form-group col-2">
                            <label>Flag for Review</label>
                            <div>
                              <input
                                type="checkbox"
                                id="is_review"
                                name="is_review"
                                style="height: 52px; width: 27px"
                                true-value="1"
                                false-value="0"
                                v-model="detail.is_review" />
                            </div>
                          </div>
                          <div class="form-group col-6">
                            <label></label>
                            <textarea
                              type="text"
                              name="Current_Responsibility"
                              class="form-control"
                              placeholder=""
                              v-model="detail.reason_for_flag"></textarea>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-12 col-sm-12 text-center mt-2">
                        <button id="save-button" class="save-btn px-4 ml-3">Save</button>
                        <button type="button" class="fil-btn px-4 ml-3" v-on:click="$router.go(-1)" id="cancel-button">
                          Cancel
                        </button>
                      </div>
                    </Form>
                    <!-- ========================= -->
                    <!-- ✅ TEAM EXECUTIVE MODAL -->
                    <!-- ========================= -->
                    <div v-if="id">
                      <TeamExecutiveModal ref="teamExecutiveModal" :team-page-url="detail.team_page_url" />
                    </div>
                  </div>
                </div>
                <ErrorComponentNew ref="errorComponent" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <TextModal ref="addSegmentModal">
      <div class="p-4">
        <h5 class="mb-3">Add Segment</h5>

        <div class="form-group">
          <!-- <label>Segment Name</label> -->
          <input
            type="text"
            class="form-control"
            v-model="newSegmentName"
            placeholder="Enter segment name"
          />
        </div>

        <div class="text-right mt-3">
          <button class="fil-btn mr-2" @click="closeAddSegmentPopup">
            Cancel
          </button>
          <button class="save-btn" @click="saveNewSegment">
            Save
          </button>
        </div>
      </div>
    </TextModal>
  </div>
</template>
<script>
// import ErrorComponent from "@/components/ErrorComponent";
import { Form, Field, ErrorMessage } from "vee-validate";
import Multiselect from "@vueform/multiselect";
import ImagePicker from "@/components/ImagePicker.vue";
import TextModal from "@/components/TextModal";
// import Datepicker from "@vuepic/vue-datepicker";
// import "@vuepic/vue-datepicker/dist/main.css";
import PhoneCode from "@/components/PhoneCodePicker/PhoneCode";
import TeamExecutiveModal from "@/components/TeamExecutiveModal.vue";
import ErrorComponentNew from "@/components/ErrorComponentNew";
export default {
  name: "Add Package Group",
  components: {
    Form,
    Field,
    ErrorMessage,
    PhoneCode,
    ImagePicker,
    Multiselect,
    ErrorComponentNew,
    TextModal,
    TeamExecutiveModal,
  },
  computed: {
    companyOptions() { // Doing this becuase when comes from TeamExecutiveModal - the company_name may not be in the companyList options - so need to add it dynamically
      if (!this.detail.company_name) return this.companyList;

      // Check if current value exists in options
      const exists = this.companyList.find(
        e => e.company_name === this.detail.company_name
      );

      if (!exists) {
        return [
          ...this.companyList,
          {
            company_name: this.detail.company_name,
            company_logo: null,
            new_company: null,
          }
        ];
      }
      return this.companyList;
    }    
  },  
  data() {
    return {
      id: this.$route.params.id,
      loader: false,
      isShow: false,
      isEditingCompanyDesc: true,
      highlightedCompanyDesc: "",
      scrappingCompanyResponse: null,

      fetchTeamExecutivesLoading: false,
      companyAiLoader: false,
      // using on i button - to show popover using below 2 variables
      singleCompanyShowOnUi: null,
      showSingleCompanyInfo: false,      

      skill_list: [],
      save_skill_list: [],
      skillKeyword: "",
      detail: {
        s3_base_url: "",
        company_name: "",
        company_website: "",
        deal_stage_id: "",
        company_size: "",
        city_id: "",
        company_type: "",
        is_pending: "N",
        social_media: [{}],
        interting_article: [
          {
            title: "",
            url: "",
            category_id: "",
          },
        ],
        interting_bite: [
          {
            news: "",
            source: "",
            category_id: "",
          },
        ],
        company_desc: "",
        skill_ids: [],
        save_skill_ids: [],
        segment_ids: [],
      },
      showTechType: false,
      companyList: [],
      revenueList: [],
      currencyList: [],
      topicList: [],
      jobFunctionList: [],
      industryList: [],
      senioritylevelList: [],
      countryList: [],
      cityList: [],
      city_ids: [],
      expansionList: [],
      regionList: [],
      deaStageList: [],
      subsectorsList: [],
      segment_list: [],
      cityKeyword: "A",
      companyKeyword: "",
    };
  },
  mounted() {
    this.industrylist();
    this.CountryList();
    this.topiclist();
    this.Expansionlist();
    this.getrevenuelist();
    this.getcurrencyList();
    this.listRegion();
    this.getdealStageList();
    // this.CityList();
    if (this.id) {
      this.getDetail();
      this.getSegmentList();
    } else {
      this.getskillList();
    }
  },
  methods: {
    getCompanyDetailsAi() {
      if (!this.detail.company_website) {
        this.$notify({
          type: "error",
          text: "Please enter website url first.",
        });
        return;
      }

      this.companyAiLoader = true; // START LOADER

      // CALL API HERE
      this.$api
        .postAPI({
          _action: "/fetch-single-company-from-ai",
          _body: {
            url: this.detail.company_website,
          },
        })
        .then((res) => {
          if (!res.detail) {
            this.$notify({
              type: "error",
              text: "No details found from website.",
            });
            return;
          }
          this.detail = { ...this.detail, ...res.detail };
          // using on i button - to show popover using below 2 variables
          this.singleCompanyShowOnUi = res.show_on_ui || null;
          this.showSingleCompanyInfo = false;          
        })
        .catch(() => {
          this.$notify({
            type: "error",
            text: "Failed to fetch company details.",
          });
        })
        .finally(() => {
          this.companyAiLoader = false; // STOP LOADER
        });
    },
    openExecutiveModal() {
      if (!this.detail.team_page_url) {
        this.$notify({
          type: "error",
          text: "Please enter team page url first.",
        });
        return;
      }

      // 🔄 loader ON
      this.fetchTeamExecutivesLoading = true;      

      // CALL API HERE
      this.$api.postAPI({
        _action: "/company/team-page-executives",
        _body: {
          url: this.detail.team_page_url,
          company_id : this.id,
        },
      }).then((res) => {
        if (!res || !res?.detail?.length) {
          this.$notify({
            type: "error",
            text: "No executives found from team page.",
          });
          return;
        }

        // STORE IN SHARED SERVICE
        this.$shareService.setMapValue("team_ai_executives", res.detail);
        this.$shareService.setMapValue("team_ai_executives_show_on_ui", res.show_on_ui);

        // OPEN MODAL       
        this.$refs.teamExecutiveModal.open();
      })
      .catch(() => {
        this.$notify({
          type: "error",
          text: "Something went wrong while fetching team members.",
        });
      })
      .finally(() => {
        // 🔄 loader OFF
        this.fetchTeamExecutivesLoading = false;
      });
    },
    openAddSegmentPopup() {
      this.newSegmentName = "";
      this.$refs.addSegmentModal.showModal();
    },

    closeAddSegmentPopup() {
      this.$refs.addSegmentModal.closeModal();
    },
    saveNewSegment() {
      if (!this.newSegmentName.trim()) return;

      // 🔹 ADD MODE (company not saved yet)
      if (!this.id) {
        if (!Array.isArray(this.detail.segment_ids)) {
          this.detail.segment_ids = [];
        }

        this.detail.segment_ids.push(this.newSegmentName);

        this.segment_list.push({
          id: this.newSegmentName,
          name: this.newSegmentName,
        });

        this.closeAddSegmentPopup();
        return;
      }

      // 🔹 EDIT MODE
      const obj = {
        name: this.newSegmentName,
        company_id: this.id,
      };

      this.$api
        .postAPI({
          _action: "/segments/add",
          _body: obj,
        })
        .then((res) => {
          this.$notify({
            type: "success",
            text: res.message,
          });

          if (!Array.isArray(this.detail.segment_ids)) {
            this.detail.segment_ids = [];
          }

          // ✅ PUSH THE NEW SEGMENT ID
          this.detail.segment_ids.push(res.id);

          // ✅ REFRESH LIST (no param needed)
          this.getSegmentList();

          this.closeAddSegmentPopup();
        });
    },
    getSegmentList(id = null) {
      const obj = {};
      this.segment_list = [];
      this.$api
        .getAPI({
          _action: "/segments/list_unpaged/" + this.id,
          _body: obj,
        })
        .then((res) => {
          this.segment_list = res;

          if (id) this.detail.segment_ids.push(res.id);
        })
        .catch(() => {});
    },
    handleIndustryChange(event) {
      const selectedIndustryId = event.target.value;
      this.selectedIndustry = selectedIndustryId;

      const selectedIndustry = this.industryList.find(
        industry => industry.id == selectedIndustryId
      );
      console.log('selectedIndustry-', JSON.stringify(selectedIndustry));

      // Reset by default
      this.showTechType = false;

      // Show Tech Focus ONLY for Technology as client said.
      if (selectedIndustry?.industry_name === 'Technology' && selectedIndustry.sub_sector_count > 0) {
        this.showTechType = true;
        this.getSubsectorList(selectedIndustryId);
      }

      if (!this.showTechType) this.detail.subsector_id = "";
    },
    searchSkillName(e) {
      if (!e) return;
      this.skillKeyword = e;
      this.getskillList();
    },
    getskillList() {
      var obj = {};
      if (this.skillKeyword) {
        obj.keyword = this.skillKeyword;
      }
      if (this.detail.skill_ids?.length > 0) {
        obj.selected_ids = this.detail.skill_ids;
      }
      this.$api
        .getAPI({
          _action: "/skills/list_unpaged",
          _body: obj,
        })
        .then((res) => {
          this.skill_list = res;
          this.skillKeyword = "";
        })
        .catch(() => {});
    },
    onToggleHighlightCompanyDesc() {
      if (this.isEditingCompanyDesc) {
        this.isEditingCompanyDesc = false;
        this.highlightCompanySkills();
      } else {
        this.isEditingCompanyDesc = true;
      }
    },

    highlightCompanySkills() {
      const paragraph = this.detail.company_desc?.trim();
      if (!paragraph) return;

      this.$api
        .postAPI({
          _action: "/scrapping/company",
          _body: { paragraph: this.detail.company_desc },
        })
        .then((res) => {
          if (res.status === "success") {
            this.highlightedCompanyDesc = res.highlighted_description;
            this.scrappingCompanyResponse = res;
          }
        });
    },
    prefillDropdown() {
      if (!this.scrappingCompanyResponse) {
        this.$notify({ type: "error", text: "Run highlight first." });
        return;
      }

      const res = this.scrappingCompanyResponse;

      if (res.skills) {
        this.skill_list = this.mergeOptions(this.skill_list, res.skills);
      }

      if (res.skills_ids) {
        this.detail.skill_ids = this.mergeIds(this.detail.skill_ids, res.skills_ids);
      }
    },
    async applyDropdowns(is_message_show = false) {
      this.detail.skill_ids = (this.detail.skill_ids || []).map(Number);

      this.detail.save_skill_ids = [];
      this.save_skill_list = [];

      await this.$nextTick();

      this.getSaveListCommon("/skills/list_unpaged", this.detail.skill_ids, "save_skill_list");

      setTimeout(() => {
        this.detail.save_skill_ids = [...this.detail.skill_ids];

        if (is_message_show) {
          this.$notify({
            type: "success",
            text: "Applied changes successfully.",
          });
        }
      }, 300);
    },
    // Merge options uniquely (by id)
    mergeOptions(existing = [], incoming = []) {
      const map = new Map();

      existing.forEach((item) => {
        if (item && item.id) map.set(item.id, item);
      });

      incoming.forEach((item) => {
        if (item && item.id) map.set(item.id, item);
      });

      return Array.from(map.values());
    },
    // Merge IDs uniquely
    mergeIds(target = [], incoming = []) {
      // Normalize existing IDs first
      let normalized = target.map((id) => Number(id)).filter((id) => !isNaN(id));
      const set = new Set(normalized);

      incoming.forEach((id) => {
        const num = Number(id);
        if (!set.has(num)) {
          set.add(num);
          normalized.push(num); // mutation of new array, not target
        }
      });

      return normalized;
    },
    getSaveListCommon(api, ids, assignTo) {
      const obj = {};

      if (ids && ids.length > 0) {
        obj.selected_ids = ids; // Correct key name
      }

      this.$api
        .getAPI({
          _action: api,
          _body: obj,
        })
        .then((res) => {
          this[assignTo] = res; // <-- ⭐ Correct way to assign dynamic variable
        })
        .catch(() => {});
    },
    searchCompanyName(e) {
      this.companyKeyword = e;
      this.companylist();
    },
    searchCityName(e) {
      this.cityKeyword = e;
      this.CityList();
    },
    listRegion() {
      this.$api
        .getAPI({
          _action: "/region/list",
        })
        .then((res) => {
          this.regionList = res;
        })
        .catch(() => {});
    },
    getcurrencyList() {
      this.$api
        .getAPI({
          _action: "/currency/list",
        })
        .then((res) => {
          this.currencyList = res;
        })
        .catch(() => {});
    },
    getrevenuelist() {
      this.$api
        .getAPI({
          _action: "/revenue/list",
        })
        .then((res) => {
          this.revenueList = res;
        })
        .catch(() => {});
    },
    getdealStageList() {
      this.$api
        .getAPI({
          _action: "/funding_series/list",
        })
        .then((res) => {
          this.deaStageList = res.list;
        })
        .catch(() => {});
    },
    addLinkObj() {
      this.detail.interting_article.push({});
    },
    removeLinkObj(index) {
      this.detail.interting_article.splice(index, 1);
    },
    addBitesObj() {
      this.detail.interting_bite.push({});
    },
    removeBitesObj(index) {
      this.detail.interting_bite.splice(index, 1);
    },
    addPlatform() {
      if (this.detail.social_media.length < 3) {
        this.detail.social_media.push({});
      }
    },
    removePlatform(index) {
      this.detail.social_media.splice(index, 1);
    },
    getDetail() {
      // this.$refs.errorComponent.updateFormLoader(true);
      this.$refs.errorComponent.showLoading({ title: "Loading", message: "Please wait...", position: "top", });
      this.$api
        .getAPI({
          _action: "/company/detail/" + this.id,
        })
        .then((res) => {
          this.detail = res;
          if (this.detail.company_name) {
            this.companyKeyword = this.detail.company_name;
            this.companylist();
          }
          this.city_ids.push(this.detail.city_id);
          this.detail.social_media = [];
          if (this.detail.facebook_url) {
            var obj1 = {
              platform_type: "Facebook",
              url: this.detail.facebook_url,
            };
            this.detail.social_media.push(obj1);
          }
          if (this.detail.twitter_url) {
            var obj2 = {
              platform_type: "Twitter",
              url: this.detail.twitter_url,
            };
            this.detail.social_media.push(obj2);
          }
          if (this.detail.linkedin_url) {
            var obj3 = {
              platform_type: "LinkedIn",
              url: this.detail.linkedin_url,
            };
            this.detail.social_media.push(obj3);
          }
          if (this.detail.social_media.length == 0) {
            this.detail.social_media.push({});
          }
          this.searchCityName();
          this.loader = false;
          if (this.detail.interting_article.length <= 0) {
            this.detail.interting_article.push({});
          }
          if (this.detail.interting_bite.length <= 0) {
            this.detail.interting_bite.push({});
          }

          if (this.$refs.errorComponent) {
            // this.$refs.errorComponent.setData(res);
            this.$refs.errorComponent.updateFormLoader(false);
          }
          this.detail.subsector_id = res.subsector_id;
          if (this.detail.industry_id) {
            this.handleIndustryChange({ target: { value: this.detail.industry_id } });
          }
          this.detail.deal_stage_id = res.funding_series_id;

          // Prefill skills IDs only
          if (res.company_skills && Array.isArray(res.company_skills)) {
              this.detail.skill_ids = res.company_skills.map(item => item.skill_id);
              this.getskillList();
          }

          this.applyDropdowns(); //  after prefill the editable dropdonws need to prefill Non Editable too.

          // Prefill company-wise segments
          if (res.company_segments && Array.isArray(res.company_segments)) {
            // dropdown options
            this.segment_list = res.company_segments;

            // selected ids for multiselect
            this.detail.segment_ids = res.company_segments.map(seg => seg.id);
          }

        })
        .catch(() => {
          this.loader = false;
          if (this.$refs.errorComponent) {
            // this.$refs.errorComponent.setData(0, undefined, "");
            this.$refs.errorComponent.updateFormLoader(false);
          }
        });
    },
    Expansionlist() {
      this.$api
        .getAPI({
          _action: "/artical/category/list",
        })
        .then((res) => {
          this.expansionList = res;
        })
        .catch(() => {});
    },
    CountryList() {
      this.$api
        .getAPI({
          _action: "/country/list",
        })
        .then((res) => {
          this.countryList = res;
        })
        .catch(() => {});
    },
    CityList(country_id) {
      var obj = {};
      if (this.cityKeyword) {
        obj.keyword = this.cityKeyword;
      }
      if (this.city_ids.length > 0) {
        obj.city_ids = this.city_ids;
      }
      if (country_id) {
        obj.country_id = country_id;
        for (var i in this.countryList) {
          if (country_id == this.countryList[i].id) {
            this.detail.country_code = this.countryList[i].country_code;
            this.detail.region_id = this.countryList[i].region_id;
          }
        }
      }
      if (this.detail.country_id) {
        obj.country_id = this.detail.country_id;
      }
      this.$api
        .getAPI({
          _action: "/city/list",
          _body: obj,
        })
        .then((res) => {
          this.cityList = res;
          this.city_ids = [];
        })
        .catch(() => {});
    },
    seniorityList() {
      this.$api
        .getAPI({
          _action: "/seniority/list",
        })
        .then((res) => {
          this.senioritylevelList = res;
        });
    },
    jobFunctionlist() {
      this.$api
        .getAPI({
          _action: "/job/function/list",
        })
        .then((res) => {
          this.jobFunctionList = res;
        })
        .catch(() => {});
    },
    industrylist() {
      this.$api
        .getAPI({
          _action: "/industry/subsector-count/list",
        })
        .then((res) => {
          this.industryList = res;
        })
        .catch(() => {});
    },
    getSubsectorList(id) {
      this.$api
        .getAPI({
          _action: "/subsectors/list/" + id,
        })
        .then((res) => {
          this.subsectorsList = res.list;
        })
        .catch(() => {});
    },
    topiclist() {
      this.$api
        .getAPI({
          _action: "/topic/list",
        })
        .then((res) => {
          this.topicList = res;
        })
        .catch(() => {});
    },
    companylist() {
      var obj = {};
      if (this.companyKeyword) {
        obj.keyword = this.companyKeyword;
      }
      this.$api
        .getAPI({
          _action: "/company/list",
          _body: obj,
        })
        .then((res) => {
          this.companyList = res;
          for (var a in this.companyList) {
            this.companyList[a].disabled = true;
          }
        })
        .catch(() => {});
    },
    onChange(e) {
      let files = e.target.files;
      if (files[0].type.toLowerCase() != "image/jpeg" && files[0].type.toLowerCase() != "image/png") {
        alert("Invalid file formate, please use jpeg or png file.");
        return;
      }
      // const size = (files[0].size / 1024 / 1024).toFixed(2);
      // if (size > 10) {
      //   alert("File must be less then 10 MB");
      //   return;
      // }
      var tmppath = URL.createObjectURL(files[0]);
      this.file = files[0];
      document.getElementById("preview").src = tmppath;
    },
    save() {
      if (this.isShow) {
        return;
      }
      if (!this.$refs.ImagePicker.file && !this.detail.company_logo) {
        this.$notify({
          type: "error",
          text: "Please upload company logo",
        });
        return;
      }
      if (this.detail.social_media.length > 0) {
        this.detail.linkedin_url = "";
        this.detail.facebook_url = "";
        this.detail.twitter_url = "";
        for (var a in this.detail.social_media) {
          if (this.detail.social_media[a].platform_type == "LinkedIn") {
            this.detail.linkedin_url = this.detail.social_media[a].url;
          }
          if (this.detail.social_media[a].platform_type == "Facebook") {
            this.detail.facebook_url = this.detail.social_media[a].url;
          }
          if (this.detail.social_media[a].platform_type == "Twitter") {
            this.detail.twitter_url = this.detail.social_media[a].url;
          }
        }
      }
      if (this.detail.interting_article.length > 0 && this.detail.interting_article[0].category_id == "") {
        this.detail.interting_article = [];
      }
      if (this.detail.interting_bite.length > 0 && this.detail.interting_bite[0].category_id == "") {
        this.detail.interting_bite = [];
      }
      if (this.id) { // Doing this becuase in case of edit we have id so segment seperate add will work but in add case it will not work... so save the segments from company add api
        this.detail.segment_ids = this.detail.segment_ids || [];
      }
      if (this.id) {
        this.$api
          .putAPI({
            _action: "/company",
            _body: this.detail,
            _buttonId: "save-button",
          })
          .then((res) => {
            if (!this.$refs.ImagePicker.file) {
              this.$router.go(-1);
            } else {
              this.uploadImage(res.id);
            }
          })
          .catch(() => {});
      } else {
        this.$api
          .postAPI({
            _action: "/company",
            _body: this.detail,
            _buttonId: "save-button",
          })
          .then((res) => {
            // After company create/update
            const companyId = res.id;

            // Case 1 – Manual file upload
            if (this.$refs.ImagePicker.file) {
              this.uploadImage(companyId);
              return;
            }
            // Case 2 – URL based image (AI or edited)
            if (this.detail.company_logo) {
              var s3baseurl = (this.detail.s3_base_url || '').replace(/\/+$/, '') // remove trailing slash(s) (amazonaws.com)
              console.log(' cleans3baseurl ', s3baseurl); 
              // If already S3 type URL
              if (this.detail.company_logo.includes(s3baseurl)) {
                this.uploadImageFromExternalUrl(companyId);
              } else {
                this.uploadImageFromExternalUrl(companyId);
              }
              return;
            }
            this.$router.go(-1);
          })
          .catch(() => {});
      }
    },
    uploadImage(id) {
      this.$api
        .uploadImageAPI({
          _action: "/company/logo",
          _key: "image",
          _file: this.$refs.ImagePicker.file,
          _body: {
            id: id,
          },
        })
        .then((res) => {
          this.$notify({
            type: "success",
            text: res.message,
          });
          this.$router.go(-1);
        })
        .catch(() => {
          // ❗ error already notified in WebService
          // so nothing required here unless you want UI state changes
        });        
    },
    uploadImageFromExternalUrl(id) {
      if (!id || !this.detail.company_logo) return;

      var obj = {
        id: id,
        url: this.detail.company_logo,
        type: 'COMPANY'
      };

      this.$api.postAPI({
        _action: "/upload/image-external-url",
        _body: obj,
      })
      .then((res) => {
        this.$notify({
          type: "success",
          text: res.message,
        });
        this.$router.go(-1);
      });
    },
  },
};
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style scoped>
.multiselect {
  background: white !important;
  height: auto !important;
  border: 1px solid;
}

.multiselect-tag {
  background: #9cc338 !important;
}

.option-icon {
  width: 25px;
  height: 25px;
  border-radius: 15px;
  margin-right: 10px;
}
.biography-buttn {
  /* --- GREEN GRADIENT --- */
  background: linear-gradient(to right, #4caf50 0%, #45a049 50%, #4caf50 100%) !important;
  color: #fff !important;

  /* --- SHADOW + BORDER --- */
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.14);
  border: 1px solid transparent;
  border-radius: 5px;

  /* --- SMALL BUTTON SIZE --- */
  font-size: 12px !important;
  font-weight: 400;
  line-height: 1 !important;
  height: 28px !important;
  padding: 2px 10px !important;

  /* --- EXTRA --- */
  cursor: pointer;
  display: inline-block;
}
.multiselect-add-option {
  padding: 10px 12px;
  cursor: pointer;
  font-weight: 500;
  color: #007bff;
  border-top: 1px solid #eee;
}

.multiselect-add-option:hover {
  background: #f5f7fa;
}
.ai-info-wrapper {
  position: relative;
}

.ai-info-popup {
  position: absolute;
  top: 34px;
  left: 0;
  right: auto;

  min-width: 420px;
  max-width: 520px;
  max-height: 260px;
  overflow-y: auto;

  background: #fff;
  border: 1px solid #ddd;
  padding: 10px 12px;
  font-size: 12px;
  line-height: 1.4;
  z-index: 9999;
}

.ai-popup-header {
  display: flex;
  justify-content: center;
  margin-bottom: 8px;
}

.ai-popup-avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  object-fit: contain;
  background: #f5f5f5;
}
.ai-info-btn {
  cursor: pointer;
  font-size: 20px;
}
.ai-info-row {
  padding: 6px 0;
  border-bottom: 1px solid #eee;
}

.ai-info-row:last-child {
  border-bottom: none;
}
.ai-info-row {
  display: flex;
  gap: 6px;
}

.ai-info-row strong {
  min-width: 100px;
  font-weight: 600;
  color: #000;
}
</style>
